import { render } from "./Web_design.vue?vue&type=template&id=bbb85c2c"
import script from "./Web_design.vue?vue&type=script&lang=js"
export * from "./Web_design.vue?vue&type=script&lang=js"
script.render = render

export default script